/**
 * 覆いかぶさるメニュー（開閉ボタン1つバージョン）
 */

import { bodyScrollFixed } from '../../assets/scripts/_bodyScrollFixed';
import { fadeInElement, fadeOutElement } from '../../assets/scripts/_fade';

const MENU_TOGGLE_TRIGGER = '.js-flopoverMenu_btn';
const MENU_CONTAINER = '.js-flopoverMenu';
const OPEN_CLASS = 'is-opened';
const CLOSE_CLASS = 'is-closing';
const SPEED = 500;

/** ========================
 * メニュー共通設定
 * ========================== */
function _menuInit( target ) {
	let target_menu = document.getElementById( target );
	bodyScrollFixed( true ); //スクロール停止

	target_menu.classList.add( OPEN_CLASS );
	fadeInElement( target_menu, SPEED );
}

//閉じる
function _menuCloseInit( target ) {
	let target_menu = document.getElementById( target );
	fadeOutElement( target_menu, SPEED );
	target_menu.classList.add( CLOSE_CLASS );
	target_menu.classList.remove( OPEN_CLASS );
	document.querySelectorAll( MENU_TOGGLE_TRIGGER ).forEach( ( trigger ) => {
		trigger.classList.remove( OPEN_CLASS );
	} );

	// アニメーション用のクラスを削除
	setTimeout( function () {
		target_menu.classList.remove( CLOSE_CLASS );
	}, SPEED );

	//メニューが閉じたときスクロール復活
	bodyScrollFixed( false ); //スクロール復活

	return false;
}

/** ========================
 * ボタン押下時にメニュー出現
 * ========================== */
function fnc_flopoverMenuCtrl() {
	// MENU_CONTAINERにdata-lenis-prevent属性を追加（lenis対策）
	document.querySelectorAll( MENU_CONTAINER ).forEach( ( container ) => {
		container.setAttribute( 'data-lenis-prevent', 'true' );
	} );

	// メニューの状態を追跡
	let menuIsOpen = false;
	let currentTarget = null;

	document.querySelectorAll( MENU_TOGGLE_TRIGGER ).forEach( ( trigger ) => {
		trigger.addEventListener( 'click', function ( e ) {
			e.preventDefault();

			// 開くメニューターゲットを取得
			let target = this.getAttribute( 'data-target' );

			if ( ! menuIsOpen || currentTarget !== target ) {
				// メニューが閉じている、または別のターゲットを開く場合
				_menuInit( target );
				this.classList.add( OPEN_CLASS );
				menuIsOpen = true;
				currentTarget = target;
			} else {
				// メニューが既に開いている場合は閉じる
				_menuCloseInit( target );
				this.classList.remove( OPEN_CLASS );
				menuIsOpen = false;
				currentTarget = null;
			}
		} );
	} );

	//ページ内リンクをクリックした場合にメニューを閉じる
	document
		.querySelectorAll( `${ MENU_CONTAINER } a[href]` )
		.forEach( ( link ) => {
			link.addEventListener( 'click', function () {
				let target =
					this.closest( MENU_CONTAINER ).getAttribute( 'id' );
				if ( menuIsOpen ) {
					_menuCloseInit( target );
					menuIsOpen = false;
					currentTarget = null;
				}
			} );
		} );
}

/** ========================
 * 実行
 * ========================== */
window.addEventListener(
	'load',
	() => {
		fnc_flopoverMenuCtrl();
	},
	false
);
